import React, { FC } from 'react';
import { TRichTextEditorFormat } from '../models';

interface IRichTextEditorToolbarProps {
  id: string;
  formats: TRichTextEditorFormat[];
}

export const RichTextEditorToolbar: FC<IRichTextEditorToolbarProps> = ({ id, formats }) => {
  return (
    <div id={id}>
      <span className="ql-formats">
        {formats.includes('h2') && (
          <button className="ql-header ql-title" value="2">
            H2
          </button>
        )}
        {formats.includes('h3') && (
          <button className="ql-header ql-title" value="3">
            H3
          </button>
        )}
        {formats.includes('h4') && (
          <button className="ql-header ql-title" value="4">
            H4
          </button>
        )}
        {formats.includes('bold') && <button className="ql-bold" />}
        {formats.includes('listBullet') && <button className="ql-list" value="bullet" />}
        {formats.includes('listOrdered') && <button className="ql-list" value="ordered" />}
        {formats.includes('link') && <button className="ql-link" />}
        {formats.includes('showMoreHr') && <button className="ql-hr">-</button>}
      </span>
    </div>
  );
};
